import { useFlagsmithGetFlagValue } from 'lib/flagsmith'
import { isAppWebView } from 'lib/utils/common/commonUtils'

export default function useMobileGallery(isPhone, phone) {
  const variant = useFlagsmithGetFlagValue(
    'Exp_Product_Img_Catalogue20260915',
    'B',
  )
  return Boolean((isPhone || phone) && !isAppWebView() && variant === 'A')
}
